import { TagType } from 'entities/tag';

/**
 * Maps a concept's base type to the iXBRL tag type. Handles BOTH vocabularies:
 * taxonomy concepts carry `baseXsdType` ('monetary', 'decimal', …) while
 * extension concepts carry `baseXbrliType` ('monetaryItemType', …) — the
 * ItemType suffix is normalized away so extensions tag as nonFraction too.
 */
export const getTagType = (baseType: string | null | undefined): TagType => {
  const normalized = (baseType ?? '').replace(/ItemType$/, '');
  switch (normalized) {
    case 'decimal':
    case 'monetary':
    case 'integer':
    case 'percent':
    case 'shares':
      return 'nonFraction';
    case 'fraction':
      return 'fraction';
    case 'string':
    case 'boolean':
    case 'date':
    default:
      return 'nonNumeric';
  }
};
